module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--dashboard"
  }, [_c('span', {
    staticClass: "d-nav__toggle no-select",
    on: {
      "click": function($event) {
        _vm.toggleDashboard()
      }
    }
  }, [_c('span', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "p"
  }, [_vm._v(_vm._s((_vm.toggleText + " Dashboard")))])])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard group"
  }, [_c('pages-dashboard-navigation'), _vm._v(" "), _c('b', {
    class: [
      "d-nav__underlay",
      {
        'd-nav__underlay--active': _vm.dashboardTransitionState === "show" || _vm.dashboardTransitionState === "in",
      }
    ]
  }), _vm._v(" "), _c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loader",
      "mode": "out-in"
    },
    on: {
      "appear": function($event) {
        _vm.onLoad()
      },
      "enter": function($event) {
        _vm.onLoad()
      },
      "leave": function($event) {
        _vm.onLeave()
      }
    }
  }, [_c('div', {
    staticClass: "dashboard__panel"
  }, [(_vm.infoCTAVisible() && _vm.notOnStepPage()) ? _c('ui-tooltip', {
    attrs: {
      "level": "tip"
    }
  }, [_c('span', {
    staticClass: "info-request-cta",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [(_vm.user.role === 1 && _vm.offTourStep(1)) ? [_c('p', [_vm._v("Your profile hasn't been completed yet. Please update your information "), _c('module-link', {
    attrs: {
      "link": "dashboard-profile-info"
    }
  }, [_c('strong', [_vm._v("here")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.showTour === "reviewer") ? [_c('h4', [_vm._v("You're on your way to becoming a reviewer!")]), _vm._v(" "), _c('ul', {
    staticClass: "info-request-cta__step-counter"
  }, [_c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(1)
    }]
  }, [_vm._v("1: Enter your profile information on your "), _c('module-link', {
    attrs: {
      "link": "dashboard-profile-info"
    }
  }, [_c('strong', [_vm._v("profile page")])])], 1), _vm._v(" "), _c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(2)
    }]
  }, [_vm._v("2: Add a location to your "), _c('module-link', {
    attrs: {
      "link": "dashboard-dentist-locations"
    }
  }, [_c('strong', [_vm._v("location page")])])], 1), _vm._v(" "), _c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(3)
    }]
  }, [_vm._v("3: Apply to become a reviewer on the "), _c('module-link', {
    attrs: {
      "link": "dashboard-reviewer-application"
    }
  }, [_c('strong', [_vm._v("reviewer applicaton page")])])], 1)])] : _vm._e(), _vm._v(" "), (_vm.showTour === "dentist") ? [_c('h4', [_vm._v("Your profile hasn't been completed yet. Please update your information.")]), _vm._v(" "), _c('ul', {
    staticClass: "info-request-cta__step-counter"
  }, [_c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(1)
    }]
  }, [_vm._v("1: Enter your profile information on your "), _c('module-link', {
    attrs: {
      "link": "dashboard-profile-info"
    }
  }, [_c('strong', [_vm._v("profile page")])])], 1), _vm._v(" "), _c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(2)
    }]
  }, [_vm._v("2: Add a location to your "), _c('module-link', {
    attrs: {
      "link": "dashboard-dentist-locations"
    }
  }, [_c('strong', [_vm._v("location page")])])], 1)])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145ebaee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Dashboard.vue
// module id = 329
// module chunks = 0